import { getNumberOfDotUnit } from '@gp/utils/common';
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Table } from 'tea-component';
const { autotip, pageable, scrollable } = Table.addons;
export const LivePageDataTable = (props: any) => {
  const {
    total,
    records = [],
    pageSize,
    pageIndex,
    isLoading,
    handleOnPagingChange,
    addonsCfg,
    showPagination = true,
    className,
    tableBodyMaxH,
    pageSizeOptions = [10, 20, 50, 100],
    ...restProps
  } = props || {};
  const isShowPageCfg = total > Math.min(...pageSizeOptions);
  const addons = useMemo(() => {
    const defaultAddons = [
      showPagination
        ? pageable({
          pageSizeOptions,
          recordCount: total,
          pageCountChangingResetType: 'first',
          pageSize,
          pageIndex,
          pageSizeVisible: isShowPageCfg,
          pageIndexVisible: isShowPageCfg,
          jumpVisible: isShowPageCfg,
          endJumpVisible: isShowPageCfg,
          onPagingChange: handleOnPagingChange,
          stateTextVisible: true,
          stateText: `${getNumberOfDotUnit(total)} item${total > 1 ? 's' : ''
            } in total`,
        })
        : [],
      scrollable({
        maxHeight: tableBodyMaxH || 'unset',
      }),
      autotip({
        isLoading,
        hideIcon: !isLoading, // loading状态显示图标，其他情况不显示
        emptyText: 'No data matches the current filters. Please adjust and try again.',
        style: {
          height: 172,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
        },
      }),
      ...(addonsCfg || []),
    ];
    return defaultAddons;
  }, [
    showPagination,
    pageSizeOptions,
    total,
    pageSize,
    pageIndex,
    isShowPageCfg,
    handleOnPagingChange,
    tableBodyMaxH,
    isLoading,
    addonsCfg,
  ]);
  return (
    <Table
      {...restProps}
      className={classNames(className, {
        'dbh-action-state-center-table': true,
        'dbg-common-table': true,
      })}
      addons={addons}
      records={isLoading ? [] : records || []}
    />
  );
};
